import { render, staticRenderFns } from "./CoachClients.vue?vue&type=template&id=27f14376&scoped=true&"
import script from "./CoachClients.vue?vue&type=script&lang=ts&"
export * from "./CoachClients.vue?vue&type=script&lang=ts&"
import style0 from "./CoachClients.vue?vue&type=style&index=0&id=27f14376&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f14376",
  null
  
)

export default component.exports